<template>
  <v-flex v-if="check === true" mr-2>
    <v-checkbox
      ref="search"
      :label="placeholder"
      v-model.trim="datasource.args[attr]"
      hide-details
      @change="inputEvent($event)"
    >
    </v-checkbox>
  </v-flex>
  <v-flex v-else mr-2>
    <v-flex v-if="type === 'date'">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="
              datasource.args[attr] ? dateFormatter(datasource.args[attr]) : ''
            "
            :label="placeholder"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            filled
            v-on="on"
            @input="
              inputEvent($event);
              menu = false;
            "
            clearable
            hide-details="auto"
            @click:clear="datasource.args[attr] = null"
          ></v-text-field>
        </template>
        <v-date-picker
          ref="search"
          :label="placeholder"
          v-model.trim="datasource.args[attr]"
          :date-formatter="dateFormatter"
          :close-on-content-click="false"
          :readonly="readonly"
          append-icon="search"
          @input="
            inputEvent($event);
            menu = false;
          "
          :show-current="true"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex v-else>
      <v-flex v-if="type === 'select'">
        <v-select
          v-model="datasource.args[attr]"
          :items="items"
          append-icon="search"
          :label="placeholder"
          :item-text="itemText"
          :item-value="itemValue"
          hide-details="auto"
          filled
          clearable
          @change="inputEvent($event)"
        >
        </v-select>
      </v-flex>
      <v-flex v-else>
        <v-text-field
          ref="search"
          :label="placeholder"
          v-model.trim="localValue"
          hide-details
          filled
          clearable
          append-icon="search"
          @input="inputEvent($event)"
          :type="typeChamp"
        />
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import { parseDate, formatFromIsoToFrDate } from '@/utils/date';

export default {
  props: {
    datasource: {
      type: Object,
      required: true,
    },
    attr: {
      type: String,
      default: 'name',
    },
    check: {
      type: Boolean,
    },
    i18n: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    typeChamp: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    itemText: {
      type: String,
      default: 'libelle',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    dateValue: null,
  },
  data() {
    return {
      localValue: this.datasource.args[this.attr],
      menu: false,
      //valueField: this.$refs.search.value,
    };
  },
  watch: {
    localValue(val) {
      this.datasource.args[this.attr] =
        this.type === 'date' ? parseDate(val) : val;
    },
  },
  mounted() {
    this.$nextTick(function() {
      if (this.dateValue) {
        this.$refs.search.localValue = this.dateValue;
        this.datasource.args[this.attr] = this.dateValue;
      }
    });
  },
  computed: {
    placeholder() {
      if (this.i18n) {
        return this.$t(this.i18n);
      }
      if (
        this.$te(
          this.datasource.labelNamespace + '.list.search.' + this.attr,
          this.$i18n.fallbackLocale,
        )
      ) {
        return this.$t(
          this.datasource.labelNamespace + '.list.search.' + this.attr,
        );
      } else {
        return this.$t(this.datasource.labelNamespace + '.search.' + this.attr);
      }
    },
  },
  methods: {
    focus() {
      this.$refs.search.focus();
    },
    inputEvent(event) {
      this.datasource.pagination.page = 1;
      this.datasource.debouncedRefresh();
      this.$emit('storeSearch', event);
    },
    dateFormatter(date) {
      return formatFromIsoToFrDate(date);
    },
  },
};
</script>
